import React from 'react'
import { Tabs } from '~/shared/ui/RoutesTabs/type'
import { DamagesPage } from './Damages'
import { DetailsPage } from './Details'
import { ViolationsPage } from './Violations'

export const useConfigTabs = (): Tabs => {
  return [
    {
      labelI18n: 'details',
      path: '/details',
      content: <DetailsPage />,
    },
    {
      labelI18n: 'damages',
      path: '/damages',
      content: <DamagesPage />,
    },
    {
      labelI18n: 'violations',
      path: '/violations',
      content: <ViolationsPage />,
    },
  ]
}
